class Saver {
	#instance;
	hash = {};
	saving = 0;

	constructor(instance) {
		this.#instance = instance;
	}

	incSaving() {
		this.saving++;
		this.#instance.$emit("set-saving", this.saving);
	}

	decSaving() {
		this.saving--;
		this.#instance.$emit("set-saving", this.saving);
		if (this.saving === 0) {
			this.computeHashes();
		}
	}

	error() {
		this.decSaving();
		this.#instance.$emit("saving-failed");
	}

	computeHashes() {
		for (let x of this.#instance.data.data) {
			this.hash[x._id] = this.#instance.$hash(x);
		}
	}

	save(modifyCallback, deleteCallback) {
		console.log("saving");
		let hashKeys = new Set(Object.keys(this.hash));
		for (let x of this.#instance.data.data) {
			hashKeys.delete(x._id);
			if (!x._id || this.hash[x._id] !== this.#instance.$hash(x)) {
				console.log(this.saving, x._id);
				this.incSaving();
				modifyCallback(x);
			}
		}
		console.log("delete");
		for (let x of hashKeys) {
			console.log(this.saving, x);
			this.incSaving();
			deleteCallback(x);
		}
	}
}

export default(Saver);